// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import domReady from '@wordpress/dom-ready';

// import styles bundle
import 'swiper/css/bundle';

domReady(() => {
  new Swiper('.latest-news-swiper', {
    slidesPerView: 1,
    spaceBetween: 40,
    a11y: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 80,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  const section = document.querySelector('.latest-news[data-listing-url]');
  if (!section) return;

  const listingUrl = section.dataset.listingUrl;

  section.addEventListener('click', (e) => {
    const badge = e.target.closest('.content-card__badge');
    if (!badge) return;

    e.preventDefault();
    e.stopPropagation();

    const categoryName = badge.textContent.trim();
    const separator = listingUrl.includes('?') ? '&' : '?';
    window.location.href =
      listingUrl +
      separator +
      'findstr[filter][category][value]=' +
      encodeURIComponent(categoryName) +
      '&findstr[group]=news';
  });
});
